import {useEffect, useRef, useState} from 'react';

/**
 * Retrieved from https://stackoverflow.com/a/45323523
 * @param initialIsVisible
 * @returns {{ref: React.MutableRefObject<null>, isComponentVisible: unknown, setIsComponentVisible: React.Dispatch<React.SetStateAction<unknown>>}}
 * @example
 * const Dropdown = () => {
 *     const {ref, isComponentVisible} = useComponentVisible(true);
 *     return (
 *         <div ref={ref}>
 *             {isComponentVisible && (<p>Dropdown Component</p>)}
 *         </div>
 *     )
 * }
 *
 */
export default function useComponentVisible(initialIsVisible) {
    const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
    const ref = useRef(null);

    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setIsComponentVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    });

    return {
        ref,
        isComponentVisible,
        setIsComponentVisible
    };
}
